// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin_header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 80px;
	background: #4b4b4b;
	box-shadow: 1px 0 2px rgba(0, 0, 0, 0.125);
	display: flex;
	align-items: center;
	z-index: 100;
}

.admin_header .logo {
	width: 280px;
	padding: 0 25px;
	color: white;
	letter-spacing: 2px;
	text-transform: uppercase;
	border-right: 1px solid #f5f5f5;

}

.admin_header .logo img {
	height: 25px !important;
}

.admin_header .menu {
	width: calc(100% – 250px);
	padding: 0 25px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.admin_header .hamburger {
	font-size: 20px;
	cursor: pointer;
	color: white;
	position: absolute;
	top: 22px;
}

.admin_header .hamburger:hover {
	color: #f29109;
}

.admin_header .header-menu {

	width: calc(100vw - 305px);
	padding-right: 25px;
}

.admin_header .header-menu .access-oof,
.admin_header .header-menu .download-report {
	color: white;
	float: right;
	padding: 0px 25px;
	border-right: solid 1px white;
	cursor: pointer;
	font-weight: 500;
}

.admin_header .header-menu .access-oof>svg,
.admin_header .header-menu .download-report>svg {
	margin-bottom: 3px;
	margin-right: 4px;
}

.admin_header .header-menu .download-report:hover,
.admin_header .header-menu .access-oof:hover {
	color: #f29109;
}

.admin_header .user {
	color: white;
	float: right;
	padding: 0px 25px;
	font-weight: 400;
	margin-left: 70px;

}

.admin_header .user svg {
	color: white;
	margin-left: 5px;
	font-size: 20px;
}

.admin_header .user>svg {
	margin-right: 5px;
	background-color: #f29109;
	font-size: 10px;
	height: 20px;
	width: 20px;
	border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AdminLayout/admin_header.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,0CAA0C;CAC1C,aAAa;CACb,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,+BAA+B;;AAEhC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;;CAEC,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;;AAElB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB","sourcesContent":[".admin_header {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 80px;\n\tbackground: #4b4b4b;\n\tbox-shadow: 1px 0 2px rgba(0, 0, 0, 0.125);\n\tdisplay: flex;\n\talign-items: center;\n\tz-index: 100;\n}\n\n.admin_header .logo {\n\twidth: 280px;\n\tpadding: 0 25px;\n\tcolor: white;\n\tletter-spacing: 2px;\n\ttext-transform: uppercase;\n\tborder-right: 1px solid #f5f5f5;\n\n}\n\n.admin_header .logo img {\n\theight: 25px !important;\n}\n\n.admin_header .menu {\n\twidth: calc(100% – 250px);\n\tpadding: 0 25px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.admin_header .hamburger {\n\tfont-size: 20px;\n\tcursor: pointer;\n\tcolor: white;\n\tposition: absolute;\n\ttop: 22px;\n}\n\n.admin_header .hamburger:hover {\n\tcolor: #f29109;\n}\n\n.admin_header .header-menu {\n\n\twidth: calc(100vw - 305px);\n\tpadding-right: 25px;\n}\n\n.admin_header .header-menu .access-oof,\n.admin_header .header-menu .download-report {\n\tcolor: white;\n\tfloat: right;\n\tpadding: 0px 25px;\n\tborder-right: solid 1px white;\n\tcursor: pointer;\n\tfont-weight: 500;\n}\n\n.admin_header .header-menu .access-oof>svg,\n.admin_header .header-menu .download-report>svg {\n\tmargin-bottom: 3px;\n\tmargin-right: 4px;\n}\n\n.admin_header .header-menu .download-report:hover,\n.admin_header .header-menu .access-oof:hover {\n\tcolor: #f29109;\n}\n\n.admin_header .user {\n\tcolor: white;\n\tfloat: right;\n\tpadding: 0px 25px;\n\tfont-weight: 400;\n\tmargin-left: 70px;\n\n}\n\n.admin_header .user svg {\n\tcolor: white;\n\tmargin-left: 5px;\n\tfont-size: 20px;\n}\n\n.admin_header .user>svg {\n\tmargin-right: 5px;\n\tbackground-color: #f29109;\n\tfont-size: 10px;\n\theight: 20px;\n\twidth: 20px;\n\tborder-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
